import React from 'react';
import {FontStyles, Routes} from "../../components/constants";
import uuid from 'uuid/v4'
import {dbStories} from "components/firebase";
import {Flex} from "components/common_style/flex";
import titlebg from '../../assets/backgrounds/title.jpg';
import {Span} from "components/common_style/text";
import {TextInput} from "components/common_style/text_input";
import {Colors} from "components/constants";
import {Button, ButtonOutline} from "components/common_style/button";
import {ReactComponent as ImagePlaceholder} from "assets/icons/image_placeholder.svg";
import {CardContainer} from "components/story_card/story_card_view";
import StoryEditor, {TITLE_LAYOUT_A, TITLE_LAYOUT_B, TITLE_LAYOUT_C} from "pages/story_editor/story_editor";
import {Localization} from "localizations/languages";

class StoryEditorLayout extends React.Component {
    setTitle;

    constructor(props) {
        super(props);
        if (window.location.hash.length === 0) props.history.replace(Routes.myStories);
        this.state = {
            uuidKey: uuid(),
            loading: true,
            title: '',
            name: '',
        };
        this.storyId = this._parseHashStoryId(window.location.hash);
        this.pageN = this._parseHashPage(window.location.hash);
        if (this.storyId.length === 0) {
            this.props.history.replace(Routes.myStories);
            return;
        }
        this.story = dbStories.doc(this.storyId);
        this._loadData();

    }

    _parseHashStoryId(hash) {
        hash = hash.substring(1);
        if (hash.includes('&')) {
            return hash.split('&')[0]
        } else {
            return hash;
        }
    }

    _parseHashPage(hash) {
        if (hash.includes('&')) {
            return parseInt(hash.split('&')[1]);
        } else {
            return 0;
        }
    }

    async _loadData() {
        try {
            this.storyData = (await this.story.get()).data();
        } catch (e) {
            // error.code === 'permission-denied'
            this.props.history.replace(Routes.myStories);
            return;
        }

        this.setState({
            title: this.storyData.title,
            name: this.storyData.author
        })
    }

    render() {
        let titleCenter = <Flex column hAlign={'center'}>
            <div style={{
                width: 170,
                height: 25,
                backgroundColor: '#F9BFA0',
                marginBottom: 5
            }}/>
            <div style={{
                width: 130,
                height: 20,
                backgroundColor: '#F9BFA0'
            }}/>
        </Flex>;
        let titleLeft = <div>
            <div style={{
                width: 170,
                height: 25,
                backgroundColor: '#F9BFA0',
                marginBottom: 5
            }}/>
            <div style={{
                width: 130,
                height: 20,
                backgroundColor: '#F9BFA0'
            }}/>
        </div>;
        return <Flex column hAlign={'center'}
                     style={{width: 1200, margin: 'auto', height: '100%'}}>
            <Flex hAlign={'center'} style={{marginTop: 50}}>
                <Span textStyle={FontStyles.titleDarkLarge}>{Localization.current.translation50}</Span>
            </Flex>
            <Flex row style={{width: '100%', backgroundColor: 'white', margin: '30px 0 30px 0'}}>
                <Flex column>
                    <Span textStyle={FontStyles.labelGray}>{Localization.current.translation61}</Span>
                    <CardContainer onClick={() => this.setTitle(TITLE_LAYOUT_A)} style={{
                        border: 'solid 1px ' + Colors.button,
                        width: 300,
                        height: 180,
                        padding: 5,
                        margin: '10px 0 25px'
                    }}>
                        {titleCenter}
                    </CardContainer>
                    <Span textStyle={FontStyles.labelGray}>{Localization.current.translation62}</Span>
                    <CardContainer onClick={() => this.setTitle(TITLE_LAYOUT_B)} style={{
                        border: 'solid 1px ' + Colors.button,
                        width: 300,
                        height: 180,
                        padding: 5,
                        margin: '10px 0 25px',
                        justifyContent: 'flex-end'
                    }}>
                        {titleCenter}
                    </CardContainer>
                    <Span textStyle={FontStyles.labelGray}>{Localization.current.translation63}</Span>
                    <CardContainer onClick={() => this.setTitle(TITLE_LAYOUT_C)} style={{
                        border: 'solid 1px ' + Colors.button,
                        width: 300,
                        height: 180,
                        padding: 5,
                        margin: '10px 0 25px',
                        alignItems: 'flex-start'
                    }}>
                        {titleLeft}
                    </CardContainer>

                </Flex>
                <Flex column style={{marginTop: 25, marginLeft: 20}} vAlign={'center'}>
                    <Span textStyle={FontStyles.darkLabelLarge}>{Localization.current.translation64}</Span>
                    <div style={{width: 880, height: 495, position: 'relative', overflow: 'hidden', marginTop: 20}}>
                        <StoryEditor setTitleLayout={(fn) => this.setTitle = fn} preview={true} width={880}
                                     height={495}/>
                    </div>
                </Flex>
            </Flex>

            <Flex wmax>
                <ButtonOutline onClick={() => this.back()}
                               style={{
                                   width: 200,
                                   height: 45,
                                   margin: 10
                               }}>{Localization.current.translation51}</ButtonOutline>
                <ButtonOutline onClick={() => this.cancelAndQuit()} style={{
                    width: 200,
                    height: 45,
                    margin: 10
                }}>{Localization.current.translation52}</ButtonOutline>
                <Button onClick={() => this.publishStory()}
                        style={{
                            width: 200,
                            height: 45,
                            margin: 10,
                            marginLeft: 'auto'
                        }}>{Localization.current.translation54}</Button>
            </Flex>
        </Flex>;
    }

    cancelAndQuit() {
        this.props.history.replace(Routes.myStories);
    }

    onTitleChange(e) {
        this.setState({
            title: e.target.value
        })
    }

    onAuthorChange(e) {
        this.setState({
            name: e.target.value
        })
    }

    back() {
        this.props.history.replace(Routes.storyEditorWHash(this.storyId, this.pageN));
    }


    async publishStory() {
        // await this.story.update({
        // });
        this.props.history.replace(Routes.myStories);

    }
}

export default StoryEditorLayout;
